import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const BannerWidgetSwipeLayoutStyle = styled.div`
  width: 100%;
  padding: 0 15px;

  &:has(.is-not-img-margin) {
    padding: 0;
  }

  .slick-list {
    width: 100%;

    .slick-track {
      height: auto;

      .slick-slide {
        width: 100%;

        & > div {
          width: 100%;
          overflow: hidden;

          .amondz-img {
            border-radius: 2px;
          }
        }
      }
    }
  }

  .is-float-right {
    .slick-list {
      float: right;
    }
  }

  .is-float-left {
    .slick-list {
      float: left;
    }
  }

  .swipe_1_dot_5,
  .swipe_2_dot_5 {
    display: block;
    overflow: hidden;

    .slick-list {
      overflow: visible;
      margin-left: -10px;
      width: calc(90% + 16px);

      .slick-track {
        .slick-slide {
          & > div {
            width: auto;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .slick-dots {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    height: 8px;

    li {
      margin: 0;
      width: 8px;
      height: 8px;

      &:not(:last-child) {
        margin-right: 6px;
      }

      button {
        width: 0;
        height: 0;
        padding: 0;
        display: inline-block;

        &:before {
          width: 0;
          height: 8px;
          line-height: 8px;
        }
      }
    }
  }
`;
